export default __webpack_public_path__ + "static/media/bootstrap.806b6bc5.png";